import { render, staticRenderFns } from "./Startpage.vue?vue&type=template&id=f7abe7e8&"
import script from "./Startpage.vue?vue&type=script&lang=ts&"
export * from "./Startpage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports